/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import * as Config from "./config";

async function reqTipoCambio() {
  const API_URI_TIPO_CAMBIO = Config.rutasInterconexion.tipodecambio;
  try {
    const response = await axios.get(API_URI_TIPO_CAMBIO);
    return response.data.items;
  } catch (error) {
    console.error(error);
    return error;
  }
}

export default {
  reqTipoCambio,
};
